import React from 'react';
import PropTypes from 'prop-types';
import { Col, Well, Clearfix } from 'react-bootstrap';
import { I18N } from '../../../../../constants';
import { formatDateTime } from '../../../../../shared/utils/date';
import { formatStopLocation } from '../../../../../shared/utils/run';
import FieldGroup from '../../../../../components/FieldGroup';

const AbnormalityInfo = props => (
    <Col sm={12}>
        <Well>
            <Col sm={6}>
                <FieldGroup
                    label="Abnormality Type"
                    value={I18N.ABNORMALITIES[props.abnormalityType]}
                    horizontal
                    noBottomMargin
                    readOnly
                />
                <FieldGroup
                    label="Abnormality Status"
                    value={I18N.ABNORMALITY_STATUS[props.abnormalityStatus]}
                    horizontal
                    noBottomMargin
                    readOnly
                />
                <FieldGroup
                    label="Trailer Number"
                    value={props.trailerIdentifier}
                    horizontal
                    noBottomMargin
                    readOnly
                />
            </Col>
            <Col sm={6}>
                <FieldGroup
                    label="Abnormality Date"
                    value={formatDateTime(props.abnormalityDate)}
                    horizontal
                    noBottomMargin
                    readOnly
                />
                <FieldGroup
                    label="Abnormality Location"
                    value={formatStopLocation(props.abnormalityLocation)}
                    horizontal
                    noBottomMargin
                    readOnly
                />
            </Col>
            <Clearfix />
        </Well>
    </Col>
);

AbnormalityInfo.propTypes = {
    abnormalityType: PropTypes.string,
    abnormalityDate: PropTypes.string,
    abnormalityReason: PropTypes.string,
    abnormalityLocation: PropTypes.object,
    trailerIdentifier: PropTypes.string,
};
AbnormalityInfo.defaultProps = {};

export default AbnormalityInfo;
